<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="3">
            <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg"
              type="dark" variant="primary">
              <b-navbar-brand center>GRN List</b-navbar-brand>
              <div>
                <h5 class="text-muted justify-content-center">
                  <small>{{ totalRows }} Entries</small>
                </h5>
              </div>
            </b-navbar>
          </b-col>
          <b-col md="9">
            <h4 class="error">
              Start Date : {{ GRNdate.startDate }} / End Date : {{ GRNdate.endDate }}
            </h4>
          </b-col>
        </b-row>

        <div>
          <b-row>
            <b-col cols="2">
              <b-button v-if="All_GRN_List_data.length > 0" :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="pull-right mr-3" @click="getReports()" size="sm" variant="warning">{{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>
              <!-- <b-button class="pull-right mr-3" v-if="All_GRN_List_data.length>0" @click="getReports('BL_LIST')" size="sm"
                variant="warning">Export as Excel</b-button> -->
            </b-col>
            <b-col cols="2">
              <b-button v-if="All_GRN_List_data.length > 0"
                class="pull-right mr-3" @click="exportToExcelClient" size="sm" variant="success">
                Export (Client XLSX)
              </b-button>
            </b-col>
            <b-col md="8">
              <b-form-input  @input="filterSearch" :formatter="capitalizeAll" placeholder="Common Number" id="common_filter" name="common_filter"
                v-model="Filter.common_filter" />
            </b-col>
            <b-col md="2">
              <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible">
              Filters</b-button>
            </b-col>
          </b-row>
            
          <b-collapse class="mt-2" v-model="visible" id="collapse-2">
            <b-card>
              <b-row>
                <b-col md="3">
                  <label for="blType">Type</label>
                  <model-list-select :list="TypeList" id="clientNamenew" v-model="Filter.TypeList" option-value="val"
                    option-text="type" placeholder="Select Type"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label v-if="Filter.TypeList != '1'">GRN Date</label>
                  <label v-else>Assignment Date</label>
                  <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="GRNdate"
                    :startDate="startDate" :endDate="endDate"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Assignment No.</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Assignment No." id="assignmentNo"
                    name="assignmentNo" v-model="Filter.assignmentNo"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>All Module ID</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="All Module Id" id="allModuleId"
                    name="allModuleId" v-model="Filter.allModuleId"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Container Number</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Container Number" id="Container_number" name="Container_number"
                    v-model="Filter.Container_number"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>GRN Number</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="GRN Number" id="GRN_number" name="GRN_number"
                    v-model="Filter.GRN_number"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Booking Number</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="Booking Number" id="booking_number"
                    name="booking_number" v-model="Filter.booking_number"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>BOE Number</label>
                  <b-form-input :formatter="capitalizeAll" placeholder="BOE Number" id="BOE_number" name="BOE_number"
                    v-model="Filter.BOE_number"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Vehicle No</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']"
                    v-model="Filter.vehicleNoFilter" option-value="value" option-text="label"
                    placeholder="Select Vehicle No"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Vehicle Status</label>
                  <model-list-select :list="VehicleStatusList" v-model="Filter.vehicleStatusFilter" 
                    option-value="val" option-text="status" placeholder="Select Vehicle Status"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Pickup Location</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="Filter.PICKfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Pickup Location"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Handover Location</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="Filter.HANDfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Handover Location"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Stuffing Location</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                    v-model="Filter.STUFFfilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Stuffing Location"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client Name</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientNamenew"
                    v-model="Filter.clientIdFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name"></model-list-select>
                </b-col>
              </b-row>
              <div class="mt-3 row justify-content-center">
                <b-button size="sm" @click="filterSearch" variant="outline-primary">Search
                </b-button>
                <b-button size="sm" class="ml-2" @click="filterClear" variant="outline-info">clear</b-button>
              </div>
            </b-card>
          </b-collapse>
        </div>
        <div class="table-responsive tableMain mt-2">
          <b-table show-empty stacked="md" responsive :items="All_GRN_List_data" :fields="fields"
            primary-key="goodReceivedID" :per-page="pagination.perPage" :current-page="pagination.currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" class="position-relative">
            <template slot="goodReceivedID" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>
            <template slot="GRNSeries" slot-scope="row1">
              <span><b>GRN Series:</b> {{ row1.item.GRNSeries }}</span>
              <br />
              <span><b>GRN Date:</b> {{ row1.item.GRNDate | moment }}</span>
              <br />
              <span><b>GRN skip:</b> {{ row1.item.skipGRN }}</span>
              <br />
              <span><b>GRN Counter:</b> {{ row1.item.grnIdNew }}</span>
              <br />
              <span><b>GRN Type:</b> {{ row1.item.tptType_Status }}</span><br/>
              <span><b>Transit Status:</b> {{ row1.item.transitStatus }}</span>
            </template>

            <template slot="JobNo" slot-scope="row21">
              <b><b>Assign Number:</b> {{ row21.item.JobNo }}</b>
              <br />
              <b><b>Assign Date:</b> {{ row21.item.JobDate | moment }}</b>
              <br />
              <b><b>Raised From:</b> {{ row21.item.RaisedFrom }}</b>
              <br />
              <b><b>Rasied By:</b> {{ row21.item.RaisedBy }}</b>
            </template>
            <template slot="validBookingNo" slot-scope="row5">
              <span><b>Invoice No:</b> {{ row5.item.BillingSeries }}</span>
              <br />
              <span><b>Invoice Date:</b> {{ row5.item.BillingDate }}</span>
              <br />
              <span><b>Invoice Status:</b> {{ row5.item.INV_Status }}</span>
              <br />
              <span><b>Invoice Amount:</b> {{ row5.item.BillingAmount }}</span>
              <br />
              <span><b>Dispatch Date Time:</b> {{ row5.item.vehicleDispatchDateNew }}</span>
            </template>
            <template slot="OtherDetails" slot-scope="row3">
              <span><b>POL</b> : {{ row3.item.PICK }}</span>
              <br />
              <span><b>Stuff</b> : {{ row3.item.STUFF }}</span>
              <br />
              <span><b>Hand</b> : {{ row3.item.HAND }}</span>
              <br />
            </template>
            <template slot="clientName" slot-scope="row4">
              <span><b>Client Name: </b>{{ row4.item.clientName }}</span>
              <br />
              <span><b>Shipping Line: </b> {{ row4.item.shippingLine }}</span>
            </template>
            <template slot="containerDetails" slot-scope="row6">
              <span><b>Container No:</b> {{ row6.item.containerNo }}</span>
              <br />
              <span><b>Multi Container Type:</b> {{ row6.item.multipleContainerType }}</span>
            </template>
            <template slot="vehicledetails" slot-scope="row7">
              <span><b>Vehicle No: </b>{{ row7.item.vehicleNo }}</span>
              <br />
              <span><b>Driver Name: </b>{{ row7.item.assignedDriverName }}</span>
              <br />
              <span><b>Driver Phone No: </b>{{ row7.item.assignedDriverContact }}</span>
              <br />
              <span><b>Driver Emp Code: </b>{{ row7.item.Driver_Emp_Code }}</span>
              <br />
              <span><b>Vehicle Release Date Time: </b>{{ row7.item.vehicleReleaseDateNew }}</span>
              <b-button class="pull-right ml-2" variant="outline-info" size="sm" @click="goToMailPage('T',row7.item)">Track
                Assignment</b-button>
            </template>
            <template slot="action" slot-scope="row">
               <b-button v-if="row.item.pdfGRN" size="sm" variant="outline-info" @click="openSignedDocument(row.item.pdfGRN)">View PDF</b-button>
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination limit="10" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="totalRows" @change="onPageChange($event)"></b-pagination>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import TrasportService from "../../services/TrasportService.js";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import { GlobalGetLocation } from "../../helper/collection";
import { read, utils, writeFile } from "xlsx";
import { exportGRNListToExcel } from "../../helper/ExcelExportHelper";

export default {
  beforeMount() {
    this.getCurrentLastDate();
    if (globalPermissionStatus("Transportation") || globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/transport/tptExpense");
      this.$store.dispatch(
        "commonDropdownMaster/setAllPickupDDList",
        JSON.stringify({
          itemCode: "AllPickupList",
        })
      );
      this.$store.dispatch(
        "commonDropdownMaster/setAllStuffingDDList",
        JSON.stringify({
          itemCode: "AllStuffingList",
        })
      );
      this.$store.dispatch(
        "commonDropdownMaster/setAllHandoverDDList",
        JSON.stringify({
          itemCode: "AllHandoverList",
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$sessionsStorage.set(
        "PermissionStatus",
        globalPermissionStatus("QuotationAssignment")
      );
      this.$store.dispatch(
        "commonDropdownMaster/setAllVehicleDDList",
        JSON.stringify({
          itemCode: "getVehicleList",
          vehicleActiveInactiveId: "1",
        })
      );
      this.getGRNList("Normal");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      topcommodity: [],
      All_GRN_List_data: [],

      TypeList: [
        {
          type: "Assignemnet Date",
          val: "1",
        },
        {
          type: "GRN Date",
          val: "2",
        },
      ],
      VehicleStatusList: [
        {
          status: "IN TRANSIT",
          val: "1",
        },
        {
          status: "CLOSED",
          val: "2",
        },
        {
          status: "ALL",
          val: "3",
        },
      ],
      sortByV: null,
      sortDescV: false,
      sortDirectionV: "desc",
      ExcelBtnName: "Export as Excel",
      filterV: null,
      modalInfo: { title: "", content: "" },
      clientMaster: [],

      Filter: {
        common_filter:"",
        TypeList: "2",
        assignmentNo: "",
        allModuleId: "",
        GRN_number: "",
        Container_number:"",
        booking_number: "",
        BOE_number: "",
        PICKfilter: "",
        vehicleNoFilter: "",
        vehicleStatusFilter: "1",
        HANDfilter: "",
        STUFFfilter: "",
        clientIdFilter: "",
      },
      topTPTClientRevenue: [],
      vehicleReports: [],
      reload: true,

      visible: false,
      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "",
      endDate: "",
      GRNdate: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      pagination: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15],
      },
      totalRows: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      docURL: URL_BASE_DOC,
      fields: [
        {
          key: "goodReceivedID",
          mainkey: "goodReceivedID",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRNSeries",
          mainkey: "GRNSeries",
          label: "GRN Details",
          sortable: true,
          width: "100px",
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
          // table: "P."
        },
        {
          key: "validBookingNo",
          mainkey: "validBookingNo",
          label: "Invoice Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "OtherDetails",
          mainkey: "OtherDetails",
          label: " Other Details",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },

        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client Name",
          width: "500px",
          sortable: true,
          sortDirection: "ASC",
          //   table: "D."
        },
        {
          key: "containerDetails",
          mainkey: "containerDetails",
          label: "Container Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "vehicledetails",
          mainkey: "vehicledetails",
          label: "Vehicle Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
      NoOfAssignment: "",
      isLoading: false,
      showGraph: false,
      viewAssignment1: [],
      getCLientData: [],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() { },
  beforeDestroy() { },
  destroyed() { },
  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
    DateRangePicker,
  },
  computed: {},

  methods: {
    goToMailPage(ID,item) {
      this.$sessionsStorage.set("storeAssignId",item.assignId),
      this.$sessionsStorage.set("consomailORtrack", ID);

      this.$router.push({
        path: "/vehicleQuotation/tranportMailDetails",
      });
    },
    getReports() {
      if (this.All_GRN_List_data.length > 0) {
        this.ExcelBtnName = "Downloading....";
        let newSheetdata = [];
        this.All_GRN_List_data.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);
          let GRNSeries = obj.GRNSeries;
          let GRNDate = obj.GRNDate;
          let skipGRN = obj.skipGRN;
          let grnIdNew = obj.grnIdNew;
          let tptType_Status = obj.tptType_Status;
          let JobNo = obj.JobNo;
          let JobDate = obj.JobDate;
          let RaisedFrom = obj.RaisedFrom;
          let RaisedBy = obj.RaisedBy;
          let BillingSeries = obj.BillingSeries;
          let BillingDate = obj.BillingDate;
          let INV_Status = obj.INV_Status;
          let BillingAmount = obj.BillingAmount;
          let vehicleDispatchDateNew = obj.vehicleDispatchDateNew;
          let PICK = obj.PICK;
          let STUFF = obj.STUFF;
          let HAND = obj.HAND;
          let clientName = obj.clientName;
          let shippingLine = obj.shippingLine;
          let containerNo = obj.containerNo;
          let multipleContainerType = obj.multipleContainerType;
          let vehicleNo = obj.vehicleNo;
          let assignedDriverName = obj.assignedDriverName;
          let assignedDriverContact = obj.assignedDriverContact;
          let Driver_Emp_Code = obj.Driver_Emp_Code;
          let vehicleReleaseDateNew = obj.vehicleReleaseDateNew;

          let status;


          const newData = {
            SN: SN,
            GRNSeries: GRNSeries,
            GRNDate: GRNDate,
            skipGRN: skipGRN,
            grnIdNew: grnIdNew,
            tptType_Status: tptType_Status,
            JobNo: JobNo,
            JobDate: JobDate,
            RaisedFrom: RaisedFrom,
            RaisedBy: RaisedBy,
            BillingSeries: BillingSeries,
            BillingDate: BillingDate,
            INV_Status: INV_Status,
            BillingAmount: BillingAmount,
            vehicleDispatchDateNew: vehicleDispatchDateNew,
            PICK: PICK,
            STUFF: STUFF,
            HAND: HAND,
            clientName: clientName,
            shippingLine: shippingLine,
            containerNo: containerNo,
            multipleContainerType: multipleContainerType,
            vehicleNo: vehicleNo,
            assignedDriverName: assignedDriverName,
            assignedDriverContact: assignedDriverContact,
            Driver_Emp_Code: Driver_Emp_Code,
            vehicleReleaseDateNew: vehicleReleaseDateNew,
            transitStatus: obj.transitStatus,
          };
          newSheetdata.push(newData);
        });
        let fileName = "GRN_Master_Report_" + ".xlsx";
        const headings = [
          [
            "SN",
            "GRN No.",
            "GRN Date",
            "Skip GRN",
            "GRN Counter",
            "TRansport Type.",
            "JOb No.",
            "JOb Date.",
            "Raised From",
            "Raised By",
            "INV Series",
            "INV Date",
            "INV Status",
            "Billing Amount",
            "Vehicle Dispatch Date",
            "PICK",
            "Stuffing",
            "Handover",
            "Client Name",
            "Shipping Line",
            "Container No",
            "Container Type",
            "Vehicle No",
            "Driver Name",
            "Driver Contact",
            "Driver Emp Code",
            "Vehicle Release Date",
            "GRN Status",
          ],
        ];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
        this.ExcelBtnName = "Export as Excel";
      }
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay1 = "";
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay1 = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + lastDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      let ftoday = yyyy + "/" + mm + "/" + parseInt(dd-1); //2018-06-01
      let ltoday = yyyy + "/" + mm + "/" + dd; //2018-06-01

      this.startDate = today;
      this.GRNdate = {
        startDate: ftoday,
        endDate: ltoday,
      };
    },
    filterSearch() {
      this.reload = false;
      this.getGRNList("Normal");
    },

    getReportsBak() {
      this.ExcelBtnName = "Downloading Please Wait...";
      this.getGRNList("Excel");
    },
    filterClear() {
      (this.Filter = {
        common_filter:"",
        assignmentNo: "",
        TypeList: "1",
        allModuleId: "",
        GRN_number: "",
        Container_number:"",
        booking_number: "",
        BOE_number: "",
        PICKfilter: "",
        vehicleNoFilter: "",
        vehicleStatusFilter: "1",
        HANDfilter: "",
        STUFFfilter: "",
        clientIdFilter: "",
      }),
        (this.dateSearch.fromDate = "");
      this.dateSearch.toDate = "";
      this.getGRNList("Normal");
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.getGRNList("Normal");

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    getGRNList(type) {
      this.isLoading = true;
      this.totalRows = 0;
      this.All_GRN_List_data = [];
      let payload = {
        excelId: "Master_GRN_List",
        type: type,
        Filter: this.Filter,
        GRNdate: this.GRNdate,
      };
      TrasportService.getAllGRN_List(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("Shreshth Gahlot => ", status);
          console.log("Shreshth Gahlot => ", data);
          if (status == 200 && data) {
            this.isLoading = false;
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.All_GRN_List_data.length > 0) {
                this.All_GRN_List_data = data.All_GRN_List_data;
                this.totalRows = data.All_GRN_List_data.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.All_GRN_List_data.length > 0) {
                this.All_GRN_List_data = data.All_GRN_List_data;
                this.totalRows = data.All_GRN_List_data.length;
                console.log(" All_GRN_List Count response=>", data);
              }
            }
            this.GRNdate.startDate = data.startDate;
            this.GRNdate.endDate = data.endDate;
          }
        })
        .catch((error) => {
          console.log("Catch on All_GRN_List Error: ", error);
        });
    },
    async exportToExcelClient() {
      try {
        this.isLoading = true;
        
        // Call the new API to get GRN list data
        const payload = {
          dateRange: {
            startDate: this.GRNdate.startDate || "",
            endDate: this.GRNdate.endDate || "",
          },
          isAll: 1,
          page: 1,
          pageSize: 10000, // Get all records
        };
        
        const response = await TrasportService.getGRNListNew(payload);
        
        if (response.status === 200 && response.data && response.data.success) {
          const grnList = response.data.data || [];
          
          if (grnList.length > 0) {
            const fileName = `GRN_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            exportGRNListToExcel(grnList, fileName);
            
            this.isLoading = false;
          } else {
            this.isLoading = false;
            alert('No data available to export');
          }
        } else {
          this.isLoading = false;
          alert('Failed to fetch GRN data');
        }
      } catch (error) {
        console.error('Excel export error:', error);
        this.isLoading = false;
        alert('Failed to export Excel file');
      }
    },
  },
};
</script>
<style>
.md-theme-default.md-tabs>.md-tabs-navigation {
  background-color: #ffffff;
}

.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header {
  color: #6e6b79;
}

.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active,
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus {
  color: #6e6b79;
}

.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-indicator {
  background-color: #002b48;
  height: 4px;
  border-radius: 10px;
}

.md-whiteframe {
  background: #fff;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.423rem;
}
</style>



// WEBPACK FOOTER //
// GRNdetails.vue?32a6f412